export default "__VITE_ASSET__DpfTjFoo__"